<template>
  <v-container
    fluid
    class="orders px-2 px-md-0"
    :class="{ mobile: $vuetify.breakpoint.xsOnly }"
  >
    <v-row class="orders-content" v-if="$vuetify.breakpoint.smAndUp">
      <h2 class="mb-2">Order List</h2>
      <v-col cols="12">
        <v-row>
          <v-col cols="12">
            <v-simple-table v-if="orders">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">
                      Order Number
                    </th>
                    <th class="text-left">
                      Date
                    </th>
                    <th class="text-left">
                      Ordered By
                    </th>
                    <th class="text-left">
                      Quantity
                    </th>
                    <th class="text-left">
                      Total
                    </th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    @click="goToOrder(order)"
                    v-for="(order, index) in orders"
                    :key="index"
                  >
                    <td>{{ order.number }}</td>
                    <td>{{ order.createdAt }}</td>
                    <td>{{ order.user.firstName }} {{ order.user.lastName }}
                    <td>{{ order.quantity }}</td>
                    <td>{{ order.price.total }}</td>
                    <td width="20">
                      <v-menu offset-y bottom left>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn icon v-bind="attrs" v-on="on">
                            <v-icon class="gray--text"
                              >mdi-dots-vertical</v-icon
                            >
                          </v-btn>
                        </template>

                        <v-list>
                          <v-list-item link>
                            <v-list-item-title @click="goToOrder(order)"
                              >Detail</v-list-item-title
                            >
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="pt-0">
            <div class="pagination px-4">
              <div class="pagination-container">
                <v-container class="max-width">
                  <v-pagination
                    color="#23A0A0"
                    v-model="page"
                    :length="parseInt(total / totalVisible, 10) + 1"
                    next-icon="mdi-chevron-right"
                    prev-icon="mdi-chevron-left"
                    :page="page"
                    :total-visible="totalVisible"
                  ></v-pagination>
                </v-container>
              </div>
              <div
                class="item-per-page d-flex align-center justify-space-between"
              >
                <p>Items Per Page</p>
                <v-select
                  v-model="totalVisible"
                  :items="items"
                  dense
                ></v-select>
                <p>
                  {{ page }}/{{
                    totalVisible == 0
                      ? 1
                      : parseInt(total / totalVisible, 10) + 1
                  }}
                  Pages
                </p>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="orders-content-mobile" v-if="$vuetify.breakpoint.xsOnly">
      <v-col cols="12">
        <v-expansion-panels>
          <v-list>
            <v-list-item>
              <v-list-item-content class="flex-grow-1">
                <div>
                  <v-text-field
                    class="orders-search"
                    placeholder="Search"
                    solo
                    flat
                    dense
                    small
                    hide-details
                    append-icon="mdi-magnify"
                  ></v-text-field>
                </div>
                <div
                  class="d-flex justify-space-between align-center order-number"
                >
                  <hr class="flex-grow-1" />
                  <div><pre>    Order    </pre></div>
                  <hr class="flex-grow-1" />
                </div>
              </v-list-item-content>
            </v-list-item>
            <template v-for="order in orders">
              <v-list-item
                v-for="(item, index) in order.orderItems"
                :key="order.id + index"
              >
                <v-list-item-content class="w-100">
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      <div class="order-item">
                        <div>
                          <div
                            class="order-item-number"
                            @click="goToOrder(order)"
                          >
                            {{ order.number }}
                          </div>
                          <div class="order-item-date">
                            {{ order.createdAt }}
                          </div>
                        </div>
                        <div class="order-item-desc">
                          {{ item.name }}
                        </div>
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <div class="details">
                        <div class="d-flex justify-space-between">
                          <div>Quantity:</div>
                          <div>{{ item.quantity }}</div>
                        </div>
                        <div class="d-flex justify-space-between mt-2">
                          <div>Price:</div>
                          <div>£{{ item.amount }}</div>
                        </div>
                      </div>
                      <div class="d-flex justify-space-between total">
                        <div>Total:</div>
                        <div>£{{ order.price.subTotal }}</div>
                      </div>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list>
        </v-expansion-panels>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "OrdersComponent",
  components: {},
  data: () => ({
    page: 1,
    totalVisible: 10,
    length: 10,
    items: [
      { text: "10", value: 10 },
      { text: "15", value: 15 },
      { text: "All", value: 0 }
    ]
  }),
  computed: {
    ...mapState({
      orders: state => state.order.orders,
      total: state  => state.order.total,
      user: state   => state.auth.user
    })
  },
  mounted() {
    this.$store.dispatch("order/GET_ORDERS", {
      from: 0,
      to: 10,
      surgeryId: this.user.usurgery
    });
  },
  watch: {
    page(val) {
      let pagination = {
        itemsPerPage: this.totalVisible,
        page: val
      };
      this.updatePagination(pagination);
    },
    totalVisible(val) {
      let pagination = {
        itemsPerPage: val,
        page: this.page
      };
      this.updatePagination(pagination);
    }
  },
  methods: {
    getNumbers(start, stop) {
      return new Array(stop - start).fill(start).map((n, i) => n + i);
    },
    goToOrder(order) {
      this.$router.push({
        path: "/account/orders/" + order.id
      });
    },
    getOrders(payLoad) {
      this.$store
        .dispatch("order/GET_ORDERS", payLoad)
        .then(() => {
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          this.$swal("error", error.message, "error");
        });
    },
    updatePagination(pagination) {
      let payLoad = {};
      payLoad.from = (pagination.page * pagination.itemsPerPage - pagination.itemsPerPage);
      payLoad.to =   pagination.itemsPerPage === -1 ? this.totalItems : pagination.itemsPerPage;
      payLoad.surgeryId = this.user.usurgery

      this.getOrders(payLoad);
    }
  }
};
</script>
<style scoped lang="scss" src="./Orders.scss"></style>
<style lang="scss">
.orders {
  .v-input {
    .v-label,
    input {
      font-size: 14px;
    }
  }

  .pagination {
    .v-pagination__item {
      color: #aaa;
      outline: none;

      &--active {
        color: #000 !important;
        background-color: transparent !important;
      }
    }

    .v-pagination__navigation i {
      color: #000;
    }

    .v-pagination__navigation,
    .v-pagination__item {
      box-shadow: none;
    }
  }

  .orders-search {
    .v-input__slot {
      background: #f2f2f2 !important;
      border-radius: 5px;
    }
  }

  .v-expansion-panel-header__icon {
    display: none;
  }

  .v-expansion-panel-content__wrap {
    padding: 0;
    background: #f9f2d0;
    border-radius: 0 0 5px 5px;

    .details {
      padding: 12px 10px;
      font-size: 16px;
      font-family: Gotham-Medium;

      &:first-child {
        color: #23a0a0;
      }

      &:last-child {
        color: #656565;
      }
    }

    .total {
      background: #ff6b6b;
      padding: 12px 10px;
      border-radius: 0 0 5px 5px;
      font-size: 18px;
      font-family: Gotham-Medium;
      color: #fff;
    }
  }
}
.orders {
  > .row {
    &.orders-content {
      > .col {
        > .row {
          > .col-12 {
            .v-input.v-select {
              .v-text-field__details {
                display: none !important;
              }
            }
          }
        }
      }
    }
  }
}
</style>
